import React from 'react'
import ExpenseRequirementsAdditionalFields from 'src/app/ExpenseRequirementsAdditionalFields/ExpenseRequirementsAdditionalFields'
import { AppLocation, SidenavContentType } from 'src/navigation/appLocations'
import { AppRoute } from 'src/navigation/appRoutes'
import { expenseRequirementsAdditionalFieldsRouteProps } from 'src/navigation/routeProps'

const ExpenseRequirementsAdditionalFieldsAppRoute: AppRoute = {
  id: AppLocation.OrganizationSettingsExpenseRequirementsAdditionalFields,
  routeProps: expenseRequirementsAdditionalFieldsRouteProps,
  component: <ExpenseRequirementsAdditionalFields />,
  subRoutes: [],
  meta: { contentType: SidenavContentType.Settings },
}

export default ExpenseRequirementsAdditionalFieldsAppRoute
